import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";

import HomePage from "./pages/HomePage";
import StoryPage from "./pages/StoryPage";
import ServicesPage from "./pages/ServicesPage";
import BlogPage from "./pages/BlogPage";
import HeaderComponent from "./components/HeaderComponent";
import FooterComponent from "./components/FooterComponent";
import MobileDrawer from "./components/shared/MobileDrawer";
import ScrollProgressBar from "./components/shared/ScrollProgressBar";
import ScrollToTop from "./components/shared/ScrollToTop";
import CursorGlow from "./components/shared/CursorGlow";
import SkipLink from "./components/shared/SkipLink";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleOpenNavMenu = (open) => {
    setIsMenuOpen(open);
  };

  return (
    <div className="app-container">
      <Router>
        <ScrollToTop />
        <SkipLink />
        <ScrollProgressBar />
        <CursorGlow />
        <HeaderComponent isMenuOpen={isMenuOpen} toggleOpenNavMenu={toggleOpenNavMenu} />
        <MobileDrawer isOpen={isMenuOpen} onClose={() => toggleOpenNavMenu(false)} />
        <main id="main-content" tabIndex={-1}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/blog" element={<BlogPage />} />
          </Routes>
        </main>
        <FooterComponent />
      </Router>
    </div>
  );
}

export default App;
